import React from 'react'
import Layout from '@/components/Common/Layout'
import SEO from '@/components/Common/Seo'
import Posts from '@/components/Featured/Mundial62/Posts/Posts'
import Hero from '@/components/Featured/Mundial62/Hero'

import { useStaticQuery, graphql } from 'gatsby'

const IndexPage = () => {
  const bajada = `Ya son 60 años del que probablemente será el único mundial que se haya hecho jamás en Chile. Por eso, la fecha crece y crece con cada aniversario. Nuestra cultura fue sacudida por ese mundial: se empezó a masificar la televisión, se creó un himno de la mano del rock and roll y, para variar, hubo que ser ingenioso con los recursos debido al terrible impacto causado por el terremoto del 60. El mundial se superó con dignidad, pero se sacó adelante a pulso. Esto es Fiesta Universal, un especial de La Tercera hecho para celebrar al deporte y al balón, pero también a toda una época.`
  const data = useStaticQuery(graphql`
    query posts($fields: [WpPostFieldsEnum] = date) {
      allWpPost(
        filter: {
          categories: { nodes: { elemMatch: { name: { eq: "Mundial 62" } } } }
        }
        sort: { fields: $fields, order: DESC }
      ) {
        edges {
          node {
            id
            slug
            title
            excerpt
            postFormats {
              nodes {
                name
              }
            }
            formatFields {
              posttitle
              pretitle
              largesttitle
            }
            metaFields {
              author
              authorsite
              authorsiteurl
            }
            visualFields {
              accentcolor
              maincolor
              secondarycolor
              schema
            }
            date(formatString: "MMMM DD, YYYY")
            featuredImage {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 1920
                      placeholder: BLURRED
                      formats: [WEBP, AVIF]
                    )
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO />
      <Hero bajada={bajada} />
      <Posts posts={data.allWpPost.edges} />
    </Layout>
  )
}

export default IndexPage
